/**
 * Checks if the REACT_APP_NODE_ENV variable equals to production
 */
export const isProduction = process.env.REACT_APP_NODE_ENV === "production";
